export default "__VITE_ASSET__ba9fc348__"